import { Component, OnInit } from '@angular/core';
import { BlockAbstractComponent } from '@gallaghercp/core-frontend';

@Component({
    selector: 'core-block-announcement-banner',
    templateUrl: './block-announcement-banner.component.html',
    styleUrl: './block-announcement-banner.component.scss',
    standalone: false,
})
export class BlockAnnouncementBannerComponent extends BlockAbstractComponent implements OnInit {
    override ngOnInit() {
        super.ngOnInit();
    }

    getBg() {
        if (this.block.data.useBgImage) {
            return `url(${this.block.data.image})`;
        }

        return this.getBgColor(this.block.data.bgFillColor);
    }

    getBgColor(color: string): string {
        switch (color) {
            case 'primary':
                return 'var(--color-primary)';

            case 'secondary':
                return 'var(--color-secondary)';

            case 'black':
                return 'var(--bs-black)';

            case 'brand-light':
                return 'var(--color-brand-light)';

            case 'white':
            default:
                return 'white';
        }
    }

    parseImageUrl(url: string): string {
        return url.replace('/api/1.0/download', '/file');
    }
}
